import { createAction } from 'redux-act';

export const addBreakoutGroupListner = createAction('Group Breakout');
export const setLiveGroupDetail = createAction<any>('set live Group Breakout');
export const getGroupDetail = createAction('get Group Breakout');
export const setBreakoutGroupDetail = createAction<any>('set Group Breakout detail');
